<template>
    <div class="container is-max-widescreen has-bg-white py-5">
        <Header/>
        <Preloader :start="spin"/>
        <div>
            <div class="list-panel-header columns is-desktop has-background-info-dark px-3 has-text-white mb-0 mx-0">
                <div class="column has-text-centered has-text-left-desktop">
                    <span class="is-size-2"> {{$t('consent_list')}}</span>
                </div>
                <div class="column">
                    <div class="columns">
                        <div class="column has-text-right-desktop has-text-centered">
                            <div class="p-2 has-text-left">
                                <div class="has-text-weight-bold is-size-6" style="text-transform: capitalize">{{company.name}}</div>

                                <!-- <div class="is-size-7">{{$t('iys_no')}} - {{company.iysCode}}</div> -->
                            </div>
                        </div>
                        <div class="column has-text-right-desktop has-text-centered">
                            <b-dropdown v-model="selectedBrand" expanded aria-role="list" class="has-text-left w-100">
                                <template  #trigger>
                                   <b-button v-if="selectedBrand.brand_code=='ALL'" class="is-multiline is-large  is-justify-content-space-between w-100" icon-right="menu-down">
                                        <div class="has-text-weight-bold is-size-5">{{$t('all_brands')}}</div>
                                   </b-button>
                                   <b-button v-else class="is-multiline is-large has-text-left is-justify-content-space-between w-100" icon-right="menu-down">
                                        <div class="has-text-weight-bold is-size-5">{{selectedBrand.name | shortName(20)}}</div>
                                        <div class="is-size-7">{{$t('iys_no')}} - {{selectedBrand.brand_code}}</div>
                                   </b-button>
                                </template>

                                <b-dropdown-item :value="allBrands" aria-role="listitem"
                                @click="removeExpressionByFieldNameArray(['brand_code'])">
                                    <div class="media">
                                        <div class="media-content">
                                            <div class="has-text-weight-bold is-size-5">{{allBrands.name}}</div>
                                        </div>
                                    </div>
                                </b-dropdown-item>

                                <b-dropdown-item v-for="brand in brands" :key="brand.brand_code" :value="brand" aria-role="listitem"
                                @click="addExpression('brand_code','equals',brand.brand_code)">
                                    <div class="media">
                                        <div class="media-content">
                                            <div class="has-text-weight-bold is-size-5">{{brand.name | shortName(20)}}</div>
                                            <div class="is-size-7">{{$t('iys_no')}} - {{brand.brand_code}}</div>
                                        </div>
                                    </div>
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                </div>
            </div>
            <div class="list-body has-background-white">
                <div v-show="Object.keys(dashboard.ARAMA).length>0" class="columns is-gapless mb-1">
                    <div class="column" :class="{'is-disabled':!typeInFilterList.includes('ARAMA')}" >
                        <div class="has-background-grey-dark has-text-centered has-text-white has-border-right-dark py-1 is-clickable"
                        @click="addExpressionFromDashboard('type','equals','ARAMA')">
                            {{$t('call_consents')}}
                        </div>
                        <div class="has-border-bottom-light p-1">
                            <div class="columns mb-0 p-0">
                                <div class="column pb-0">
                                    <div class="has-text-centered has-background-grey-lighter p-2 has-border-light">
                                        <div class="dashvalue">{{dashboard.ARAMA.person_total}}</div>
                                        <div class="dashtitle">{{$t('phone_number')}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="columns mb-0 is-gapless">
                                <div class="column">
                                    <div class="p-2 has-border-light is-flex is-align-items-center is-justify-content-space-between is-clickable"
                                    :class="[isInDashboardFilter('ARAMA','ONAY')?'has-background-success is-selected-status':'has-background-success-light']"
                                    @click="addExpressionFromDashboard('status','equals','ONAY','ARAMA')">
                                        <div class="dashicon">
                                            <img :src="successIconUrl"/>
                                        </div>
                                        <div class="has-text-right">
                                            <div class="dashvalue">{{dashboard.ARAMA.ONAY}}</div>
                                            <div class="dashtitle">{{$t('approved_consent')}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="column">
                                    <div class="p-2 has-border-light  is-flex is-align-items-center is-justify-content-space-between is-clickable"
                                    :class="[isInDashboardFilter('ARAMA','RET')?'has-background-danger is-selected-status':'has-background-danger-light']"
                                    @click="addExpressionFromDashboard('status','equals','RET','ARAMA')">
                                        <div class="dashicon">
                                            <img :src="dangerIconUrl"/>
                                        </div>
                                        <div class="has-text-right">
                                            <div class="dashvalue">{{dashboard.ARAMA.RET}}</div>
                                            <div class="dashtitle">{{$t('denied_consents')}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="columns mb-0 is-gapless">
                                <div class="column">
                                    <div class="p-2 has-border-light  is-flex is-align-items-center is-justify-content-space-between is-clickable"
                                    :class="[isInDashboardFilter('ARAMA','')?'has-background-info is-selected-status':'has-background-info-light']"
                                    @click="addExpressionFromDashboard('sync_status','empty','','ARAMA')">
                                        <div class="dashicon">
                                            <img :src="transferOkIconUrl"/>
                                        </div>
                                        <div class="has-text-right">
                                            <div class="dashvalue">{{dashboard.ARAMA.ONAY + this.dashboard.ARAMA.RET}}</div>
                                            <div class="dashtitle">{{$t('consents_transferred')}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="column">
                                    <div class="p-2 has-border-light  is-flex is-align-items-center is-justify-content-space-between is-clickable"
                                    :class="[isInDashboardFilter('ARAMA','awaiting_confirmation')?'has-background-info is-selected-status':'has-background-info-light']"
                                    @click="addExpressionFromDashboard('sync_status','equals','awaiting_confirmation','ARAMA')">
                                        <div class="dashicon">
                                            <img :src="transferFailIconUrl"/>
                                        </div>
                                        <div class="has-text-right">
                                            <div class="dashvalue">{{dashboard.ARAMA.awaiting_confirmation}}</div>
                                            <div class="dashtitle">{{$t('consents_not_transferred')}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="columns mb-0 is-gapless">
                                <div class="column">
                                    <div class="p-2 has-border-light  is-flex is-align-items-center is-justify-content-space-between is-clickable"
                                    :class="[isInDashboardFilter('ARAMA','error')?'has-background-grey is-selected-status':'has-background-grey-lighter']"
                                    @click="addExpressionFromDashboard('sync_status','equals','error')">
                                        <div class="dashicon">
                                            <img :src="needInfoIconUrl"/>
                                        </div>
                                        <div class="has-text-right">
                                            <div class="dashvalue">{{$t('control')}}</div>
                                            <div class="dashtitle">{{$t('consents_missing_info')}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="column">
                                    <div class="p-2 has-border-light  is-flex is-align-items-center is-justify-content-space-between is-clickable"
                                    :class="[isInDashboardFilter('ARAMA','error_on_process')?'has-background-grey is-selected-status':'has-background-grey-lighter']"
                                    @click="addExpressionFromDashboard('sync_status','equals','error_on_process','ARAMA')">
                                        <div class="dashicon">
                                            <img :src="transferErrorIconUrl"/>
                                        </div>
                                        <div class="has-text-right">
                                            <div class="dashvalue">{{dashboard.ARAMA.error_on_process}}</div>
                                            <div class="dashtitle">{{$t('e_government_transfer_failure')}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column" :class="{'is-disabled':!typeInFilterList.includes('MESAJ')}">
                        <div class="has-background-grey-dark has-text-centered has-text-white has-border-right-dark py-1 is-clickable"
                        @click="addExpressionFromDashboard('type','equals','MESAJ')">
                            {{$t('text_consents')}}
                        </div>
                        <div class="has-border-right-light has-border-left-light has-border-bottom-light p-1">
                            <div class="columns mb-0 p-0">
                                <div class="column pb-0">
                                    <div class="has-text-centered has-background-grey-lighter p-2 has-border-light">
                                        <div class="dashvalue">{{dashboard.MESAJ.person_total}}</div>
                                        <div class="dashtitle">{{$t('phone_number')}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="columns mb-0 is-gapless">
                                <div class="column">
                                    <div class="p-2 has-border-light is-flex is-align-items-center is-justify-content-space-between is-clickable"
                                    :class="[isInDashboardFilter('MESAJ','ONAY')?'has-background-success is-selected-status':'has-background-success-light']"
                                    @click="addExpressionFromDashboard('status','equals','ONAY','MESAJ')">
                                        <div class="dashicon">
                                            <img :src="successIconUrl"/>
                                        </div>
                                        <div class="has-text-right">
                                            <div class="dashvalue">{{dashboard.MESAJ.ONAY}}</div>
                                            <div class="dashtitle">{{$t('approved_consent')}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="column">
                                    <div class="p-2 has-border-light  is-flex is-align-items-center is-justify-content-space-between is-clickable"
                                    :class="[isInDashboardFilter('MESAJ','RET')?'has-background-danger is-selected-status':'has-background-danger-light']"
                                    @click="addExpressionFromDashboard('status','equals','RET','MESAJ')">
                                        <div class="dashicon">
                                            <img :src="dangerIconUrl"/>
                                        </div>
                                        <div class="has-text-right">
                                            <div class="dashvalue">{{dashboard.MESAJ.RET}}</div>
                                            <div class="dashtitle">{{$t('denied_consents')}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="columns mb-0 is-gapless">
                                <div class="column">
                                    <div class="p-2 has-border-light  is-flex is-align-items-center is-justify-content-space-between is-clickable"
                                    :class="[isInDashboardFilter('MESAJ','')?'has-background-info is-selected-status':'has-background-info-light']"
                                    @click="addExpressionFromDashboard('sync_status','empty','','MESAJ')">
                                        <div class="dashicon">
                                            <img :src="transferOkIconUrl"/>
                                        </div>
                                        <div class="has-text-right">
                                            <div class="dashvalue">{{dashboard.MESAJ.ONAY + dashboard.MESAJ.RET}}</div>
                                            <div class="dashtitle">{{$t('consents_transferred')}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="column">
                                    <div class="p-2 has-border-light  is-flex is-align-items-center is-justify-content-space-between is-clickable"
                                    :class="[isInDashboardFilter('MESAJ','awaiting_confirmation')?'has-background-info is-selected-status':'has-background-info-light']"
                                    @click="addExpressionFromDashboard('sync_status','equals','awaiting_confirmation','MESAJ')">
                                        <div class="dashicon">
                                            <img :src="transferFailIconUrl"/>
                                        </div>
                                        <div class="has-text-right">
                                            <div class="dashvalue">{{dashboard.MESAJ.awaiting_confirmation}}</div>
                                            <div class="dashtitle">{{$t('consents_not_transferred')}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="columns mb-0 is-gapless">
                                <div class="column">
                                    <div class="p-2 has-border-light  is-flex is-align-items-center is-justify-content-space-between is-clickable"
                                    :class="[isInDashboardFilter('MESAJ','error')?'has-background-grey is-selected-status':'has-background-grey-lighter']"
                                    @click="addExpressionFromDashboard('sync_status','equals','error')">
                                        <div class="dashicon">
                                            <img :src="needInfoIconUrl"/>
                                        </div>
                                        <div class="has-text-right">
                                            <div class="dashvalue">{{$t('control')}}</div>
                                            <div class="dashtitle">{{$t('consents_missing_info')}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="column">
                                    <div class="p-2 has-border-light  is-flex is-align-items-center is-justify-content-space-between is-clickable"
                                    :class="[isInDashboardFilter('MESAJ','error_on_process')?'has-background-grey is-selected-status':'has-background-grey-lighter']"
                                    @click="addExpressionFromDashboard('sync_status','equals','error_on_process','MESAJ')">
                                        <div class="dashicon">
                                            <img :src="transferErrorIconUrl"/>
                                        </div>
                                        <div class="has-text-right">
                                            <div class="dashvalue">{{dashboard.MESAJ.error_on_process}}</div>
                                            <div class="dashtitle">{{$t('e_government_transfer_failure')}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column" :class="{'is-disabled':!typeInFilterList.includes('EPOSTA')}">
                        <div class="has-background-grey-dark has-text-centered has-text-white py-1 is-clickable"
                        @click="addExpressionFromDashboard('type','equals','EPOSTA')">
                            {{$t('email_consents')}}
                        </div>
                        <div class="has-border-bottom-light p-1">
                            <div class="columns mb-0 p-0">
                                <div class="column pb-0">
                                    <div class="has-text-centered has-background-grey-lighter p-2 has-border-light">
                                        <div class="dashvalue">{{dashboard.EPOSTA.person_total}}</div>
                                        <div class="dashtitle">{{$t('email_address')}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="columns mb-0 is-gapless">
                                <div class="column">
                                    <div class="p-2 has-border-light is-flex is-align-items-center is-justify-content-space-between is-clickable"
                                    :class="[isInDashboardFilter('EPOSTA','ONAY')?'has-background-success is-selected-status':'has-background-success-light']"
                                    @click="addExpressionFromDashboard('status','equals','ONAY','EPOSTA')">
                                        <div class="dashicon">
                                            <img :src="successIconUrl"/>
                                        </div>
                                        <div class="has-text-right">
                                            <div class="dashvalue">{{dashboard.EPOSTA.ONAY}}</div>
                                            <div class="dashtitle">{{$t('approved_consent')}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="column">
                                    <div class="p-2 has-border-light  is-flex is-align-items-center is-justify-content-space-between is-clickable"
                                    :class="[isInDashboardFilter('EPOSTA','RET')?'has-background-danger is-selected-status':'has-background-danger-light']"
                                    @click="addExpressionFromDashboard('status','equals','RET','EPOSTA')">
                                        <div class="dashicon">
                                            <img :src="dangerIconUrl"/>
                                        </div>
                                        <div class="has-text-right">
                                            <div class="dashvalue">{{dashboard.EPOSTA.RET}}</div>
                                            <div class="dashtitle">{{$t('denied_consents')}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="columns mb-0 is-gapless">
                                <div class="column">
                                    <div class="p-2 has-border-light  is-flex is-align-items-center is-justify-content-space-between is-clickable"
                                    :class="[isInDashboardFilter('EPOSTA','')?'has-background-info is-selected-status':'has-background-info-light']"
                                    @click="addExpressionFromDashboard('sync_status','empty','','EPOSTA')">
                                        <div class="dashicon">
                                            <img :src="transferOkIconUrl"/>
                                        </div>
                                        <div class="has-text-right">
                                            <div class="dashvalue">{{dashboard.EPOSTA.ONAY + dashboard.EPOSTA.RET}}</div>
                                            <div class="dashtitle">{{$t('consents_transferred')}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="column">
                                    <div class="p-2 has-border-light  is-flex is-align-items-center is-justify-content-space-between is-clickable"
                                    :class="[isInDashboardFilter('EPOSTA','awaiting_confirmation')?'has-background-info is-selected-status':'has-background-info-light']"
                                    @click="addExpressionFromDashboard('sync_status','equals','awaiting_confirmation','EPOSTA')">
                                        <div class="dashicon">
                                            <img :src="transferFailIconUrl"/>
                                        </div>
                                        <div class="has-text-right">
                                            <div class="dashvalue">{{dashboard.EPOSTA.awaiting_confirmation}}</div>
                                            <div class="dashtitle">{{$t('consents_not_transferred')}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="columns mb-0 is-gapless">
                                <div class="column">
                                    <div class="p-2 has-border-light  is-flex is-align-items-center is-justify-content-space-between is-clickable"
                                    :class="[isInDashboardFilter('EPOSTA','error')?'has-background-grey is-selected-status':'has-background-grey-lighter']"
                                    @click="addExpressionFromDashboard('sync_status','equals','error')">
                                        <div class="dashicon">
                                            <img :src="needInfoIconUrl"/>
                                        </div>
                                        <div class="has-text-right">
                                            <div class="dashvalue">{{$t('control')}}</div>
                                            <div class="dashtitle">{{$t('consents_missing_info')}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="column">
                                    <div class="p-2 has-border-light  is-flex is-align-items-center is-justify-content-space-between is-clickable"
                                    :class="[isInDashboardFilter('EPOSTA','error_on_process')?'has-background-grey is-selected-status':'has-background-grey-lighter']"
                                    @click="addExpressionFromDashboard('sync_status','equals','error_on_process','EPOSTA')">
                                        <div class="dashicon">
                                            <img :src="transferErrorIconUrl"/>
                                        </div>
                                        <div class="has-text-right">
                                            <div class="dashvalue">{{dashboard.EPOSTA.error_on_process}}</div>
                                            <div class="dashtitle">{{$t('e_government_transfer_failure')}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- {{filter}} -->
                <div class="p-2">
                    <div class="columns">
                        <div class="column">
                            <b-field grouped group-multiline>
                                <div class="control">
                                    <b-tag size="is-medium" type="has-background-info-dark has-text-white" attached :closable="selectedBrand.brand_code!=='ALL'" @close="removeExpressionFromDashboard(['brand_code'])">{{selectedBrand.name | shortName(20)}}</b-tag>
                                </div>
                                <div class="control">
                                    <b-tag size="is-medium" type="has-background-grey-dark has-text-white" attached :closable="clearFilterButton.status" @close="clearFilterButtonF()">{{clearFilterButton.label}}</b-tag>
                                </div>
                            </b-field>
                        </div>
                    </div>
                </div>
                <div class="p-2">
                    <div class="columns" v-if="!isChecked">
                        <div class="column" >
                            <div>
                                <b-dropdown :triggers="['hover']" aria-role="list">
                                    <template #trigger>
                                        <b-button class="mb-1" icon-left="plus" type="is-primary is-flex">{{$t('add_record')}}</b-button>
                                    </template>

                                    <b-dropdown-item aria-role="listitem" @click="openUpsertConsentModal('add','number',null)">Arama ve Mesaj</b-dropdown-item>
                                    <b-dropdown-item aria-role="listitem" @click="openUpsertConsentModal('add','email',null)">Email</b-dropdown-item>
                                </b-dropdown>

                                <b-button class="mb-1 ml-1" icon-left="upload" type="is-primary" outlined @click="isExcelUploadModalActive=true">{{$t('import')}}</b-button>
                                <b-button v-show="false" class="mb-1" icon-left="download" type="is-primary" outlined>{{$t('export')}}</b-button>
                            </div>
                        </div>
                        <div class="column is-flex is-justify-content-flex-end">
                            <!-- <b-field class="w-100">
                                <b-input :placeholder="$t('search')"
                                    type="search"
                                    icon-right="magnify"
                                    icon-clickable
                                    >
                                </b-input>
                            </b-field> -->

                            <section class="b-tooltips">
                                <b-dropdown
                                    position="is-bottom-left"
                                    aria-role="menu"
                                    trap-focus
                                    paddingless
                                    class="custom-dropdown">

                                    <template #trigger>
                                        <b-button icon-left="table" outlined type="is-primary" class="mx-2"></b-button>
                                    </template>

                                    <b-dropdown-item
                                        aria-role="menu-item"
                                        :focusable="false"
                                        custom
                                        type="is-primary"
                                        paddingless>
                                        <form action="" >
                                            <div class="modal-card" style="width:300px;">
                                                <div class="modal-card-body" position="is-top-right">
                                                        <b-field v-for="(column, index) in columnsTemplate"
                                                            :key="index"
                                                            class="control">
                                                                <div class="is-flex is-justify-content-space-between">
                                                                        <b-checkbox v-model="column.visible">
                                                                            {{ column.title }}
                                                                        </b-checkbox>
                                                                </div>
                                                        </b-field>
                                                </div>
                                            </div>
                                        </form>
                                    </b-dropdown-item>
                                </b-dropdown>
                            </section>

                            <b-button icon-left="filter" type="is-primary" class="ml-2" @click="openNewFilterModal()"></b-button>
                            <!-- <b-dropdown
                                position="is-bottom-left"
                                append-to-body
                                aria-role="menu"
                                trap-focus
                                paddingless
                                class="custom-dropdown"
                                ref="filtersDropdown"
                            >
                                <template #trigger>
                                    <b-button icon-left="filter" type="is-primary" class="ml-2"></b-button>
                                </template>


                                <b-dropdown-item
                                    aria-role="menu-item"
                                    :focusable="false"
                                    custom
                                    paddingless>
                                    <form action="">
                                        <div class="modal-card" style="width:300px;">
                                            <div class="modal-card-head">
                                                <b-field class="w-100">
                                                    <b-input :placeholder="$t('search')"
                                                        type="search"
                                                        icon-right="magnify"
                                                        icon-clickable
                                                        >
                                                    </b-input>
                                                </b-field>
                                            </div>
                                            <section class="modal-card-body">

                                                <b-field  v-for="filter in filterList" :key="filter.value" >
                                                    <div class="is-flex is-justify-content-space-between">
                                                        <b-radio v-model="selectedFilter"
                                                            :native-value="filter.value">
                                                            {{filter.name}}
                                                        </b-radio>
                                                        <div v-show="selectedFilter==filter.value" class="buttons">
                                                            <b-icon class="is-clickable" icon="pencil" type="is-primary"></b-icon>
                                                            <b-icon class="is-clickable" icon="delete-outline" type="is-danger"></b-icon>
                                                        </div>
                                                    </div>
                                                </b-field>

                                            </section>
                                            <footer class="modal-card-foot">
                                                <b-button
                                                    :label="$t('create_new_filter')"
                                                    type="is-primary"
                                                    @click="openNewFilterModal()" />



                                                <b-button
                                                    :label="$t('clear_filter')"
                                                    type="is-default" />
                                            </footer>
                                        </div>
                                    </form>
                                </b-dropdown-item>
                            </b-dropdown> -->

                        </div>

                    </div>

                    <!-- Home datas in table -->

                    <b-table
                        :data="concatPersonRecordsData"
                        checkbox-position="left"
                        bordered
                        :checkedRows.sync="checkedRows"
                        @check-all="checkAll('isCheckedAllRows')"

                        checkable
                        :header-checkable="true"
                        :sticky-header="true"
                        class="custom-table"
                        >

                        <b-table-column field="recipient" :visible="columnsTemplate.find(row => row.field == 'recipient').visible" :label="$t('recipient')" v-slot="props">
                            <div class="is-flex is-justify-content-space-between">
                                <b-tooltip class="custom-info-tooltip" position="is-right" multilined type="is-white" :triggers="['hover']" >
                                    <img :src="getStatusIcon(props.row.concat_records)" class="mr-2"/>

                                    <template v-slot:content>
                                        <div class="is-flex">
                                            <b-icon :icon="getStatusIconInfo(props.row.concat_records).icon" :type="getStatusIconInfo(props.row.concat_records).type"></b-icon>
                                            <span class="pl-2" v-html="getStatusIconInfo(props.row.concat_records).text"></span>
                                        </div>
                                    </template>
                                </b-tooltip>
                                {{ props.row.recipient}}
                            </div>
                        </b-table-column>




                        <b-table-column field="name_surname" :visible="columnsTemplate.find(row => row.field == 'name_surname').visible" :label="$t('name_surname')" v-slot="props">
                            <b-tooltip class="custom-info-tooltip" position="is-left" multilined type="is-light" :trigger="['hover']">
                                {{ props.row.name | shortName(15) }}
                                <template v-slot:content>
                                    {{ props.row.name | shortName(15) }}
                                </template>
                            </b-tooltip>
                        </b-table-column>





                        <b-table-column field="brand_code" :visible="columnsTemplate.find(row => row.field == 'brand_code').visible" :label="$t('brand')" v-slot="props">
                            <b-tooltip class="custom-info-tooltip" position="is-left" multilined type="is-light" :trigger="['hover']">
                                {{ getBrand(props.row.concat_records) | shortName(15) }}
                                <template v-slot:content>
                                    <div v-html="getBrand(props.row.concat_records)"></div>
                                </template>
                            </b-tooltip>
                        </b-table-column>






                        <b-table-column field="consent_status" :visible="columnsTemplate.find(row => row.field == 'consent_status').visible" :label="$t('consent_status')" centered v-slot="props">
                            <span class="status-tag" :class="getStatusClass(props.row.concat_records)">
                                {{ getStatusText(props.row.concat_records) }}
                            </span>
                        </b-table-column>

                        <b-table-column field="consent_source" :visible="columnsTemplate.find(row => row.field == 'consent_source').visible" :label="$t('consent_source')" centered v-slot="props">

                                {{ getSourceText(props.row.concat_records) }}

                        </b-table-column>

                        <b-table-column field="consent_date" :visible="columnsTemplate.find(row => row.field == 'consent_date').visible" :label="$t('consent_date')" centered v-slot="props">

                                <div class="has-text-right">{{ getConsentDate(props.row.concat_records) }}</div>
                                <div class="has-text-right has-text-grey-light">{{ getConsentTime(props.row.concat_records) }}</div>

                        </b-table-column>

                        <b-table-column field="" label="" centered v-slot="props">
                            <b-icon icon="pencil" class="is-clickable edit-icon" @click.native="openUpsertConsentModal('update',getConsentType(props.row) ,props.row.sid)"></b-icon>
                        </b-table-column>

                        <template #empty>
                            <div>{{$t('no_result')}}</div>
                        </template>

                        <template #bottom-left>

                        </template>
                    </b-table>


                </div>
            </div>
        </div>
        <!-- Filter Create Modal Begin -->
        <b-modal
        v-model="isNewFilterModalActive"
        has-modal-card
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        aria-modal
        class="has-overflow"
        >
            <div class="modal-card" style="width: 960">
                <header class="modal-card-head">
                    <p class="modal-card-title mr-2">{{$t('create_filter')}}</p>
                    <button
                        type="button"
                        class="delete"
                        @click="isNewFilterModalActive=false"/>
                </header>
                <section class="modal-card-body">
                    <div class="mb-1">
                        {{$t('filter_records_meet_criteria')}}
                    </div>
                    <div v-for="(expression,index) in filter.ands" :key="index">
                        <div class="columns filter-cols mb-1">
                            <div class="column is-4">
                                <b-field>
                                    <div class="control">
                                        <span class="select">
                                            <select v-model="expression.fieldName" @change="renewExpression(index,$event)" placeholder="">
                                                <option
                                                    v-for="option in filterFieldList"
                                                    :disabled="filter.ands.some(f =>  f.fieldName == option.prop)"
                                                    :value="option.prop"
                                                    :key="option.prop">
                                                    {{ option.label }}
                                                </option>
                                            </select>
                                        </span>
                                    </div>
                                </b-field>
                            </div>
                            <div class="column is-2">
                                <b-field>
                                    <b-select v-model="expression.operator">
                                        <option :value="operator.value" v-for="(operator,oi) in getOperatorList(expression.fieldName)" :key="oi">{{operator.label}}</option>
                                    </b-select>
                                </b-field>
                            </div>
                            <div class="column is-6">
                                <b-field grouped class="max-w-200">
                                    <b-field v-if="expression.fieldName=='type'">
                                        <b-select v-model="expression.value">
                                            <option v-for="(type,ti) in consentTypeList" :key="ti" :value="type.value">{{type.label}}</option>
                                        </b-select>
                                    </b-field>
                                    <b-field v-else-if="expression.fieldName=='status'">
                                        <b-select v-model="expression.value" v-if="expression.operator!=='not_empty'">
                                            <option value="ONAY">{{$t('ONAY')}}</option>
                                            <option value="RET">{{$t('RET')}}</option>
                                        </b-select>
                                    </b-field>
                                    <b-field v-else-if="expression.fieldName=='recipient_type'">
                                        <b-select v-model="expression.value">
                                            <option value="BIREYSEL">{{$t('personal')}}</option>
                                            <option value="TACIR">{{$t('commercial')}}</option>
                                        </b-select>
                                    </b-field>
                                    <b-field v-else-if="expression.fieldName=='source'">
                                        <b-select v-model="expression.value">
                                            <option :value="source.value" v-for="(source,si) in sourceList" :key="si">{{source.label}}</option>
                                        </b-select>
                                    </b-field>
                                    <b-field v-else-if="expression.fieldName=='sync_status'">
                                        <b-select v-model="expression.value">
                                            <option :value="status.value" v-for="(status,si) in syncStatusList" :key="si">{{status.label}}</option>
                                        </b-select>
                                    </b-field>
                                    <b-field v-else-if="expression.fieldName=='brand_code'">
                                        <b-select v-model="expression.value" @input="setBrandFromFilter(expression.value)">
                                            <option :value="brand.brand_code" v-for="(brand,bi) in brands" :key="bi">{{brand.name}}</option>
                                        </b-select>
                                    </b-field>
                                    <b-field v-else-if="['retailer_code','retailer_access'].includes(expression.fieldName)">
                                        <!-- <b-select v-model="expression.value">
                                            <option :value="vendor.iys_vendor_code" v-for="(vendor,bi) in vendors" :key="bi">{{vendor.name}}</option>
                                        </b-select> -->
                                        <b-dropdown
                                            append-to-body
                                            aria-role="menu"
                                            scrollable
                                            max-height="200"
                                            trap-focus
                                            v-model="expression.value"
                                            class="w-100"
                                            expanded
                                        >
                                            <template #trigger class="w-100">
                                                <b-button class="has-text-left w-100 select">
                                                    <span>{{getVendorName(expression.value)}}</span>
                                                </b-button>
                                            </template>

                                            <b-dropdown-item custom aria-role="listitem">
                                                <b-input v-model="vendorFilterKey" :placeholder="$t('search')" expanded />
                                            </b-dropdown-item>
                                            <b-dropdown-item v-for="(vendor, vi) of filteredVendorList" :key="vi" aria-role="listitem" :value="vendor.iys_vendor_code">{{vendor.name}}</b-dropdown-item>
                                        </b-dropdown>
                                    </b-field>
                                    <b-field v-else-if="['consent_date','date_created','iys_creation_date'].includes(expression.fieldName)">
                                        <b-datepicker
                                        :locale="$i18n.locale"
                                        v-model="expression.value"
                                        trap-focus
                                        :range="expression.operator=='between'"
                                        >
                                        </b-datepicker>
                                    </b-field>
                                    <b-field v-else>
                                        <b-input type="text" v-model="expression.value"></b-input>
                                    </b-field>

                                        <b-button type="is-danger" icon-right="delete-outline" @click="removeExpression(index)"></b-button>

                                </b-field>
                            </div>
                        </div>
                    </div>
                    <div>
                        <b-button :disabled="filter.ands.length>=filterFieldList.length||isInFilter('')" type="is-primary is-outlined" icon-left="plus" @click="addExpression()">{{$t('add_criteria')}}</b-button>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <b-button
                        :label="$t('close')"
                        @click="isNewFilterModalActive=false" />
                    <b-button
                        :label="$t('apply')"
                        @click="isNewFilterModalActive=false,getPersonsF()" />
                </footer>
            </div>
        </b-modal>
        <!-- Filter Create Modal End -->
        <!--Excel Import Begin-->
        <b-modal
        v-model="isExcelUploadModalActive"
        has-modal-card
        trap-focus
        :destroy-on-hide="true"
        aria-role="dialog"
        aria-label="Excel Upload"
        aria-modal>
            <form action="">
                <div class="modal-card" style="width: auto">
                    <header class="modal-card-head rounded-top-2">
                        <p class="modal-card-title">{{$t('excel_import_header')}}</p>
                        <button
                            type="button"
                            class="delete"
                            @click="isExcelUploadModalActive=false"/>
                    </header>
                    <section class="modal-card-body rounded-bottom-2">
                        <div class="columns">


                            <!-- Yeni dosyalarla değiştirilecek kısımlar -->

                            <div class="column">
                                <div class="card rounded-3">
                                    <div class="card-image">
                                        <figure class="image">
                                        <img :src="excelSampleUrl" class="excel-sample-images" alt="excel">
                                        </figure>
                                    </div>
                                    <div class="card-content has-background-grey-light has-text-dark has-text-centered p-2">
                                        <div class="content" v-html="$t('excel_sample_text')">

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="column">
                                <div class="card rounded-3">
                                    <div class="card-image">
                                        <figure class="image">
                                        <img :src="matchColumnsUrl" class="excel-sample-images" alt="columns">
                                        </figure>
                                    </div>
                                    <div class="card-content has-background-grey-light has-text-dark has-text-centered p-2">
                                        <div class="content" v-html="$t('match_columns_text')">

                                        </div>
                                    </div>
                                </div>
                            </div>





                        </div>
                        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                        <div>
                            <ValidationProvider :rules="fileRules" v-slot="{ errors, validate }" :bails="false">
                            <b-field class="file is-primary is-align-content-space-around is-align-items-center is-flex-direction-column is-justify-content-center" :class="{'has-name': !!selectedFile}"
                            :type="{'is-danger':errors[0]}"
                            :message="translateErrors(errors)">
                                <b-upload v-model="selectedFile" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @input="readFile(),validate" class="file-label has-text-centered has-border-light rounded-1 p-1 mb-2">
                                    <span class="file-cta">
                                        <span class="file-label">{{$t('browse_file')}}</span>
                                    </span>
                                    <span class="file-name has-background-grey-lighter" v-if="selectedFile">
                                        {{ selectedFile.name }}
                                    </span>
                                </b-upload>
                            </b-field>
                            </ValidationProvider>
                        </div>
                        <div class="has-text-centered my-2">
                            <b-checkbox v-model="uploadedFile.hasHeaderRow">{{$t('excel_file_has_headers')}}</b-checkbox>
                        </div>
                        <div class="has-text-centered mb-2">
                            <b-button
                            :label="$t('upload')"
                            type="is-primary" @click="handleSubmit(sendFileF)"/>
                        </div>
                        </ValidationObserver>
                        <div class="has-text-centered">
                            {{$t('excel_upload_info_text')}}
                        </div>
                    </section>
                </div>
            </form>
        </b-modal>

        <b-modal
        v-model="isColumnMatchModalActive"
        has-modal-card
        trap-focus
        :destroy-on-hide="true"
        aria-role="dialog"
        aria-label="Example Modal"
        aria-modal
        class=""
        >
            <form action="">
                <div class="modal-card" style="width: auto">
                    <header class="modal-card-head rounded-top-2">
                        <p class="modal-card-title">{{$t('excel_import_header')}}</p>
                        <button
                            type="button"
                            class="delete"
                            @click="isColumnMatchModalActive=false"/>
                    </header>
                    <section class="modal-card-body rounded-bottom-2">
                        <div class="block">
                            <div class="is-flex is-justify-content-left is-align-items-center">
                                <h3 class="is-size-3 has-text-weight-medium mr-3">{{$t('import_type')}}</h3>
                                <b-tooltip class="custom-info-tooltip" position="is-bottom" multilined type="is-light" :triggers="['click']" :auto-close="['outside', 'escape']">
                                    <b-icon type="is-default" icon="information"></b-icon>
                                    <template v-slot:content>
                                        <div v-html="$t('upload_type_info_popup_text')"></div>
                                    </template>
                                </b-tooltip>
                            </div>
                            <div>
                                <p>{{$t('import_type_info_text')}}</p>
                            </div>
                        </div>
                        <div class="has-border-light p-2 rounded-1 mb-2">
                            <div class="block">
                                <b-radio v-model="operation_type"
                                    name="name"
                                    native-value="insert">
                                    {{$t('add_new_record')}}
                                </b-radio>
                                <b-radio v-model="operation_type"
                                    name="name"
                                    native-value="update">
                                    {{$t('update_existing_records')}}
                                </b-radio>
                                <b-radio v-model="operation_type"
                                    name="name"
                                    native-value="upsert">
                                    {{$t('both')}}
                                </b-radio>
                            </div>
                        </div>
                        <div class="block">
                            <div class="is-flex is-justify-content-left is-align-items-center">
                                <h3 class="is-size-3 has-text-weight-medium">{{$t('brand_and_vendor_selection')}}</h3>
                            </div>
                            <div>
                                <p v-html="$t('brand_and_vendor_info_text')"></p>
                            </div>
                        </div>
                        <div class="has-border-light p-2 rounded-1 mb-2">
                            <div class="columns">
                                <div class="column">
                                    <div class="card">
                                        <header class="card-header">
                                            <p class="card-header-title">
                                            {{$t('brands_with_consents')}}
                                            </p>
                                        </header>
                                        <div class="card-content brand-checkbox-list">
                                            <b-field>
                                                <b-checkbox v-model="all_brands_selected" >{{$t('all')}}</b-checkbox>
                                            </b-field>
                                            <b-field v-for="(brand,index) in brands" :key="index">
                                                <b-checkbox v-model="brand_codes" :native-value="brand.brand_code" :disabled="all_brands_selected" @click.native="brandCheckboxToggle(brand.brand_code)">{{brand.name}}</b-checkbox>
                                            </b-field>
                                        </div>
                                        <footer class="card-content p-2 has-text-centered">
                                            <b-button type="is-outlined is-primary" @click="clearBrands()">
                                            {{$t('clear')}}
                                            </b-button>
                                        </footer>
                                    </div>
                                </div>
                                <div class="column">
                                    <div class="card">
                                        <header class="card-header">
                                            <p class="card-header-title">
                                            {{$t('vendors_with_consents')}}
                                            </p>
                                        </header>
                                        <div class="card-content py-2 px-5">
                                            <b-field>
                                                <b-input v-model="vendorFilter" :placeholder="$t('search')"
                                                    type="search"
                                                    icon="magnify"
                                                    icon-clickable
                                                    :disabled="isVendorsDisabled||all_vendors_selected">
                                                </b-input>
                                            </b-field>
                                        </div>
                                        <div class="card-content py-2 vendor-checkbox-list">
                                            <b-field>
                                                <b-checkbox v-model="all_vendors_selected" v-show="vendorFilter==''" :disabled="isVendorsDisabled">{{$t('all')}}</b-checkbox>
                                            </b-field>
                                            <b-field v-for="(vendor,index) in vendors" :key="index">
                                                <b-checkbox v-show="vendor.visible!==false" :disabled="all_vendors_selected" v-model="vendor_codes" :native-value="vendor.iys_vendor_code" v-if="brand_codes.includes(vendor.brand_code)">{{vendor.name}}</b-checkbox>
                                            </b-field>
                                        </div>
                                        <footer class="card-content p-2 has-text-centered">
                                            <b-button type="is-outlined is-primary" :disabled="isVendorsDisabled" @click="clearVendors()">
                                            {{$t('clear')}}
                                            </b-button>
                                        </footer>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="block">
                            <div class="is-flex is-justify-content-left is-align-items-center">
                                <h3 class="is-size-3 has-text-weight-medium">{{$t('match_fields')}}</h3>
                            </div>
                            <div>
                                <p>{{$t('match_fields_info_text')}}</p>
                            </div>
                        </div>
                        <div class="has-border-light p-2 rounded-1 mb-2">
                            <div class="columns column-match-wrapper">
                                <div v-for="col in 2" :key="col" class="column">
                                    <div v-for="(field,index) in consentHeaders" :key="index" >
                                        <div v-if="index<4&&col==1||index>3&&col==2" class="is-flex is-justify-items-left is-align-items-center mb-2">
                                            <div>
                                                <b-tag type="is-lighter is-large">{{$t(field.label)}}</b-tag>
                                            </div>
                                            <div>
                                                <b-icon icon="chevron-right"></b-icon>
                                            </div>
                                            <div>
                                                <b-field>
                                                    <b-select v-model="column_map[field.prop]" :placeholder="$t('select_a_field')">
                                                        <option :value="null">{{$t('select_a_field')}}</option>
                                                        <option
                                                            v-for="(option,index) in previewHeaders"
                                                            :value="index"
                                                            :key="index"
                                                            :disabled="Object.values(column_map).indexOf(index) > -1">
                                                            {{ option }}
                                                        </option>
                                                    </b-select>
                                                </b-field>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="block">
                            <div class="is-flex is-justify-content-left is-align-items-center">
                                <h3 class="is-size-3 has-text-weight-medium">{{$t('file_preview')}}</h3>
                            </div>
                            <div>
                                <p>{{$t('file_preview_info_text')}}</p>
                            </div>
                        </div>
                        <div class="block">
                            <div class="is-flex is-justify-content-left mb-1">
                                <span class="has-text-weight-bold mr-1 tag-list-label">{{$t('brands_with_consents')}} : </span>
                                <div class="truncated-tag-list">
                                    <b-tag type="is-lighter" class="mr-1" v-for="t in selectedBrandListForImport" :key="t">{{t}}</b-tag>
                                </div>
                                <b-icon icon="page-next-outline" v-if="brand_codes.length>0" class="is-clickable" @click.native="isSelectedBrandListModalActive = !isSelectedBrandListModalActive"></b-icon>
                                <div v-else>{{$t('brand_not_selected')}}</div>
                                <b-modal
                                v-model="isSelectedBrandListModalActive"
                                has-modal-card
                                trap-focus
                                :destroy-on-hide="false"
                                aria-role="dialog"
                                aria-modal>
                                    <div class="modal-card" style="width: auto">
                                        <header class="modal-card-head">
                                            <p class="modal-card-title mr-2">{{$t('brands_with_consents')}}</p>
                                            <button
                                                type="button"
                                                class="delete"
                                                @click="isSelectedBrandListModalActive=false"/>
                                        </header>
                                        <section class="modal-card-body dd-brand-list-wrapper p-0">
                                            <div class="panel-block" v-for="t in selectedBrandListForImport" :key="t">
                                                {{t}}
                                            </div>
                                        </section>
                                        <footer class="modal-card-foot">
                                            <b-button
                                                :label="$t('close')"
                                                @click="isSelectedBrandListModalActive=false" />
                                        </footer>
                                    </div>
                                </b-modal>
                            </div>
                            <div class="is-flex is-justify-content-left">
                                <span class="has-text-weight-bold mr-1 tag-list-label">{{$t('vendors_with_consents')}} : </span>
                                <div class="truncated-tag-list">
                                    <b-tag type="is-lighter" class="mr-1" v-for="t in selectedVendorListForImport" :key="t">{{t}}</b-tag>
                                </div>
                                <b-icon icon="page-next-outline" v-if="vendor_codes.length>0" class="is-clickable" @click.native="isSelectedVendorListModalActive = !isSelectedVendorListModalActive"></b-icon>
                                <div v-else>{{$t('vendor_not_selected')}}</div>
                                <b-modal
                                v-model="isSelectedVendorListModalActive"
                                has-modal-card
                                trap-focus
                                :destroy-on-hide="false"
                                aria-role="dialog"
                                aria-modal>
                                    <div class="modal-card" style="width: auto">
                                        <header class="modal-card-head">
                                            <p class="modal-card-title mr-2">{{$t('vendors_with_consents')}}</p>
                                            <button
                                                type="button"
                                                class="delete"
                                                @click="isSelectedVendorListModalActive=false"/>
                                        </header>
                                        <section class="modal-card-body dd-brand-list-wrapper p-0">
                                            <div class="panel-block" v-for="t in selectedVendorListForImport" :key="t">
                                                {{t}}
                                            </div>
                                        </section>
                                        <footer class="modal-card-foot">
                                            <b-button
                                                :label="$t('close')"
                                                @click="isSelectedVendorListModalActive=false" />
                                        </footer>
                                    </div>
                                </b-modal>
                            </div>
                        </div>
                        <div class="has-border-light p-2 rounded-1 block">
                            <b-table class="table-h-150 file-preview-table" :data="filePreviewTableData" :columns="filePreviewTableColumns" sticky-header scrollable></b-table>
                        </div>
                        <div class="block" v-if="formValidationErrors.length!==0">
                            <b-notification
                                v-for="(error,index) in formValidationErrors"
                                :key="index"
                                :closable="false"
                                type="is-danger is-light"
                                role="alert"
                                class="p-2 mb-1">
                                <b-icon icon="information" type="is-danger" size="is-small"></b-icon> {{error}}
                            </b-notification>
                        </div>
                        <div class="is-flex is-justify-content-flex-end is-align-items-center ">

                            <div class="buttons">
                                <a role="link" @click="goBackExcelModal()"><b-icon size="is-small" icon="arrow-left"></b-icon> {{$t('go_back')}}</a>
                                <b-button class="is-primary ml-5" @click="createBulkImportTaskF()"> {{$t('upload')}}</b-button>
                            </div>
                        </div>
                    </section>
                </div>
            </form>
        </b-modal>
        <!--Excel Import End-->
        <!--Add New Consent Modal Begin -->
        <b-modal
            v-model="isUpsertConsentModalActive"
            has-modal-card
            trap-focus
            :can-cancel="['x']"
            aria-role="dialog"
            aria-label="Modal"
            aria-modal
            class="has-overflow">
            <template #default="props">
                <UpsertConsent v-bind="upsertConsentModal" @close="props.close" @returnToUpdateMode="returnToUpdateMode"></UpsertConsent>
            </template>
        </b-modal>
        <!--Add New Consent Modal End-->

    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, ext ,size} from 'vee-validate/dist/rules';
import { mapActions,mapGetters } from 'vuex'
import Header from './Header'
import UpsertConsent from './UpsertConsent'
import Preloader from './Preloader'

extend('fileRequired', {
  ...required,
  message: 'file_is_required'
});

extend('validExt', {
  ...ext,
  message: 'extention_is_not_valid'
});

extend('validSize', {
  ...size,
  message: 'size_is_not_valid'
});

export default {
    name:'Home',
    components: {
        Header,
        ValidationObserver,
        ValidationProvider,
        UpsertConsent,
        Preloader
    },
    data() {

        const demoBrands = [
            {name:"V.A.S Telekomünikasyon Bilişim Sistemleri ve teknolojileri a.ş",brand_code:"35000"},
            {name:"Hardcoded Brand 1",brand_code:"35001"},
            {name:"Hardcoded Brand 2",brand_code:"35002"},
            {name:"Hardcoded Brand 3",brand_code:"35003"},
            {name:"Hardcoded Brand 4",brand_code:"35004"},
            {name:"Hardcoded Brand 5",brand_code:"35005"},
            {name:"Hardcoded Brand 6",brand_code:"35006"}
            ]
        const demoVendors = [
            {name:"Hardcoded Vendor 1",iysCode:"35000"},
            {name:"Hardcoded Vendor 1",iysCode:"35000"},
            {name:"Hardcoded Vendor 1",iysCode:"35000"},
            {name:"Hardcoded Vendor 1",iysCode:"35000"},
            {name:"Hardcoded Vendor 1",iysCode:"35000"},
            {name:"Hardcoded Vendor 1",iysCode:"35000"},
            {name:"Hardcoded Vendor 1",iysCode:"35000"},
            {name:"Hardcoded Vendor 1",iysCode:"35000"},
            {name:"Hardcoded Vendor 1",iysCode:"35000"},
            {name:"Hardcoded Vendor 1",iysCode:"35000"},
            {name:"Hardcoded Vendor 2",iysCode:"35001"}
            ]
        const demoFilters = [{name:"HardCoded Filter 1",value:"1"},
                            {name:"HardCoded Filter 2",value:"2"},
                            {name:"HardCoded Filter 3",value:"3"},
                            {name:"HardCoded Filter 4",value:"4"},
                            {name:"HardCoded Filter 5",value:"5"},
                            {name:"HardCoded Filter 6",value:"6"},
                            {name:"HardCoded Filter 7",value:"7"},
                            {name:"HardCoded Filter 8",value:"8"},
                            {name:"HardCoded Filter 9",value:"9"},
                            {name:"HardCoded Filter 10",value:"10"},
                            {name:"HardCoded Filter 11",value:"11"},
                            {name:"HardCoded Filter 12",value:"12"},
                            {name:"HardCoded Filter 13",value:"13"},
                            {name:"HardCoded Filter 14",value:"14"},
                            {name:"HardCoded Filter 15",value:"15"},
                        ]
        return {
            columnsTemplate: [
                { title: this.$t('recipient'), field: 'recipient', visible: true },
                { title: this.$t('name_surname'), field: 'name_surname', visible: true },
                { title: this.$t('brand'), field: 'brand_code', visible: true },
                { title: this.$t('consent_status'), field: 'consent_status', visible: true },
                { title: this.$t('consent_source'), field: 'consent_source', visible: true },
                { title: this.$t('consent_date'),  field: 'consent_date', visible: true }
            ],
            isSelectedBrandListModalActive:false,
            isSelectedVendorListModalActive:false,
            isNewFilterModalActive:false,
            isUpsertConsentModalActive:false,

            vendorFilterKey : "",
            data:[],
            pagingOffset:0,
            pagingSize:10,
            checkedRows:[],
            concat_records:[],
            isChecked:false,
            editRowSid:null,
            spin:false,
            allBrands:{
                name:this.$t('all_brands'),
                brand_code:"ALL"
            },

            selectedBrand:{},
            company:{
                name:"",
                iysCode:"000000"
            },
            //filter:{"$and":[{"type":'ARAMA'},{"value":{"$gt":115}},{"value":{ "$exists": true }},{"value":{"$regex":100, "$options":"im"}}]},
            filter:{
                "ands":[
                    // {"fieldName":"type","operator":"equals","value":"ARAMA","filterType":"persons"},
                    // {"fieldName":"recipient","operator":"equals","value":"053200000000","filterType":"persons"}
                ],
                "searchMode":"persons","name":"default"
            },
            defaultFilters:['brand_code','type'],
            filterFieldList:[
                {"prop":"recipient","label":this.$t('recipient')},
                {"prop":"name","label":this.$t('name_surname')},
                {"prop":"brand_code","label":this.$t('brand')},
                {"prop":"type","label":this.$t('consent_type')},
                {"prop":"status","label":this.$t('consent_status')},
                {"prop":"recipient_type","label":this.$t('recipient_type')},
                {"prop":"source","label":this.$t('consent_source')},
                {"prop":"consent_date","label":this.$t('consent_date')},
                {"prop":"retailer_code","label":this.$t('vendors_of_origin')},
                {"prop":"retailer_access","label":this.$t('vendors_with_consents')},
                {"prop":"date_created","label":this.$t('date_of_creation_on_iys_panel')},
                {"prop":"iys_creation_date","label":this.$t('date_of_cretation_on_e_government')},
                //{"prop":"origin","label":"Kayıt Aracı"},
                {"prop":"sync_status","label":this.$t('error_cause')}

            ],
            //demoBrands:demoBrands,
            filterList:demoFilters,
            selectedFilter:{},
            successIconUrl:"/static/images/icons/success.svg",
            dangerIconUrl:"/static/images/icons/danger.svg",
            transferOkIconUrl:"/static/images/icons/transfer-ok.svg",
            transferFailIconUrl:"/static/images/icons/transfer-fail.svg",
            needInfoIconUrl:"/static/images/icons/need-info.svg",
            transferErrorIconUrl:"/static/images/icons/transfer-error.svg",
            // Değiştir bu alttakileri
            excelSampleUrl:"/static/images/iys-panel-excel-01.svg",
            matchColumnsUrl:"/static/images/iys-panel-excel-02.svg",



            headerClass:"has-background-grey-lighter",
            consentStatusClassDict:{"ONAY":['tag','has-background-success-light','has-text-success'],"RET":['tag','has-background-danger-light','has-text-danger']},
            isExcelUploadModalActive:false,
            isColumnMatchModalActive:false,
            selectedFile:null,
            uploadedFile:{
                fileName:null,
                fileContent:null,
                hasHeaderRow:false
            },
            operation_type:null,
            brand_codes:[],
            vendor_codes:[],
            //vendors:demoVendors,
            demoVendors:demoVendors,
            consentHeaders:[
                {prop:'recipient',label:'recipient',required:'true'},
                {prop:'name',label:'name_surname',required:'true'},
                {prop:'status',label:'consent_status',required:'true'},
                {prop:'recipient_type',label:'recipient_type',required:'true'},
                {prop:'consent_date',label:'consent_date',required:'true'},
                {prop:'hour_of_consent_date',label:'consent_time',required:'true'},
                {prop:'transaction_type',label:'consent_type',required:'true'},
                {prop:'source',label:'consent_source',required:'true'},
                {prop:'vendor_of_origin',label:'vendors_of_origin',required:'true'},
            ],
            column_map:{
                recipient:null,
                name:null,
                status:null,
                recipient_type:null,
                consent_date:null,
                hour_of_consent_date:null,
                transaction_type:null,
                source:null,
                vendor_of_origin:null,
            },
            all_brands_selected:false,
            all_vendors_selected:false,
            vendorFilter:"",
            formValidationErrors:[],
            iconList:{"awaiting_confirmation":this.transferFailIconUrl,"error":this.needInfoIconUrl,"error_on_process":this.transferErrorIconUrl},
            //previewHeaders:["İletişim Adresi", "Ad Soyad", "Alıcı Tipi", "İzin Tipi", "İzin Durumu", "İzin Kaynağı"]
            sourceList:[
                {"value":"HS_2015", "label": this.$t("HS_2015")},
                {"value":"HS_KARAR", "label": this.$t("HS_KARAR")},
                {"value":"HS_FIZIKSEL_ORTAM", "label": this.$t("HS_FIZIKSEL_ORTAM")},
                {"value":"HS_ISLAK_IMZA", "label": this.$t("HS_ISLAK_IMZA")},
                {"value":"HS_ETKINLIK", "label": this.$t("HS_ETKINLIK")},
                {"value":"HS_ATM", "label": this.$t("HS_ATM")},
                {"value":"HS_EORTAM", "label": this.$t("HS_EORTAM")},
                {"value":"HS_WEB", "label": this.$t("HS_WEB")},
                {"value":"HS_MOBIL", "label": this.$t("HS_MOBIL")},
                {"value":"HS_MESAJ", "label": this.$t("HS_MESAJ")},
                {"value":"HS_EPOSTA", "label": this.$t("HS_EPOSTA")},
                {"value":"HS_CAGRI_MERKEZI", "label": this.$t("HS_CAGRI_MERKEZI")},
                {"value":"HS_SOSYAL_MEDYA", "label": this.$t("HS_SOSYAL_MEDYA")},
                {"value":"IYS_3338", "label": this.$t("IYS_3338")},
                {"value":"IYS_CM", "label": this.$t("IYS_CM")},
                {"value":"IYS_WEB", "label": this.$t("IYS_WEB")},
                {"value":"IYS_MOBIL", "label": this.$t("IYS_MOBIL")},
                {"value":"IYS_KISA_LINK", "label": this.$t("IYS_KISA_LINK")}
            ],
            syncStatusList:[
                {"value":"awaiting_confirmation", "label": this.$t('consents_not_transferred')},
                {"value":"error", "label": this.$t('consents_missing_info')},
                {"value":"error_on_process", "label": this.$t('e_government_transfer_failure')},
            ],
            consentTypeList:[
                //{"value":"", "label":this.$t('all_consents')},
                {"value":"ARAMA", "label":this.$t('call_consents')},
                {"value":"MESAJ", "label":this.$t('text_consents')},
                {"value":"EPOSTA", "label":this.$t('email_consents')},
            ],
            upsertConsentModal:{
                isMode : "add",
                isType : "number",
                personSid: null
            }

        }
    },
    computed:{
        ...mapGetters(['persons','brands','vendors','imported_file','dashboard','bulk_import_tasks']),
        typeInFilterList(){
            let list = []
            this.filter.ands.some(row => {
                if(row.fieldName == 'type' && row.value == 'ARAMA'){
                    list.push('ARAMA')
                }
                if(row.fieldName == 'type' && row.value == 'MESAJ'){
                    list.push('MESAJ')
                }
                if(row.fieldName == 'type' && row.value == 'EPOSTA'){
                    list.push('EPOSTA')
                }
            })
            if(list.length==0){
                list = ['ARAMA','MESAJ','EPOSTA']
            }
            return list
        },
        sidValues(){
            return this.checkedRows.map(row => row.sid)
        },
        clearFilterButton(){
            const obj = {}
            obj.label = this.$t('all_consents')
            if(this.hasExtraFiledsThen(this.defaultFilters)){
                obj.status = true
                obj.label = this.$t('filtered_consents')
            }else{
                this.filter.ands.some(row =>{
                    if(row.fieldName == 'type'){
                        obj.status = true
                        obj.label = this.consentTypeList.find((c)=>{ return c.value == row.value}).label
                    }
                })
            }
            return obj
        },
        // getSelectedDashboardFilter(){
        //     let selectedTypeFilter = {fieldNameArray:"",operator:"",value:"",label:this.$t('all_consents')}
        //     let hasSync = false
        //     let hasStatus = false
        //     this.filter.ands.some(row =>{
        //         if(row.fieldName == 'sync_status'){
        //             hasSync = true
        //             selectedTypeFilter.fieldNameArray = [row.fieldName]
        //             selectedTypeFilter.label = this.$t('filtered_consents')
        //         }else if(row.fieldName == 'status'){
        //             hasStatus = true
        //             selectedTypeFilter.fieldNameArray = [row.fieldName]
        //             selectedTypeFilter.label = this.$t('filtered_consents')
        //         }else if(row.fieldName == 'type'){
        //             selectedTypeFilter.fieldNameArray = [row.fieldName]
        //             if(row.value!==''){
        //                 selectedTypeFilter.label = this.consentTypeList.find((c)=>{ return c.value == row.value}).label
        //             }else{
        //                 selectedTypeFilter.label = ''
        //             }
        //         }
        //     })

        //     if(hasSync&&hasStatus){
        //         selectedTypeFilter.fieldNameArray = ['status','sync_status']
        //     }

        //     return selectedTypeFilter
        // },
        fileRules(){
            if(this.selectedFile!==null){
                return {validExt:"xlsx",validSize:8000}
            }else{
                return  {fileRequired:true}
            }
        },
        previewHeaders(){
            if(this.imported_file.preview){
                return this.imported_file.preview.header
            }else{
                return []
            }

        },
        filePreviewTableData(){
            if(this.imported_file.preview&&this.imported_file.preview.firstElevenRows){
                let data = this.imported_file.preview.firstElevenRows
                let fields = this.imported_file.preview.firstElevenRows[0]
                let newData =  Array.from(data, rowArray => rowArray=fields.reduce((o, key,ind) => Object.assign(o, {[key]: rowArray[ind]}), {}))
                if(newData.length>1){
                    newData = newData.splice(1,newData.length)
                }
                return newData
            }else{
                return []
            }
        },
        filePreviewTableColumns(){
            if(this.imported_file.preview&&this.imported_file.preview.firstElevenRows){
                let fields = this.imported_file.preview.firstElevenRows[0]
                return Array.from(fields, x => x={"field":x,"label":x})
            }else{
                return []
            }
        },
        isVendorsDisabled(){
            return this.brand_codes.length==0
        },
        selectedBrandListForImport(){
            return this.brand_codes.map(e => this.brands.find(b => b.brand_code==e).name)
            //return ['lorem', 'ipsum', 'dolor', 'sit', 'amet', 'consectetur','adipiscing', 'elit', 'curabitur', 'vel', 'hendrerit', 'libero','eleifend', 'blandit', 'nunc', 'ornare', 'odio', 'ut','orci', 'gravida', 'imperdiet', 'nullam', 'purus', 'lacinia','a', 'pretium', 'quis', 'congue', 'praesent', 'sagittis', 'laoreet', 'auctor', 'mauris', 'non', 'velit', 'eros','dictum', 'proin', 'accumsan', 'sapien', 'nec', 'massa','volutpat', 'venenatis', 'sed', 'eu', 'molestie', 'lacus','quisque', 'porttitor', 'ligula', 'dui', 'mollis', 'tempus','at', 'magna', 'vestibulum', 'turpis', 'ac', 'diam','tincidunt', 'id', 'condimentum', 'enim']
        },
        selectedVendorListForImport(){
            return this.vendor_codes.map(e => this.vendors.find(v => v.iys_vendor_code==e).name)
            //return ['lorem', 'ipsum', 'dolor', 'sit', 'amet', 'consectetur','adipiscing', 'elit', 'curabitur', 'vel', 'hendrerit', 'libero','eleifend', 'blandit', 'nunc', 'ornare', 'odio', 'ut','orci', 'gravida', 'imperdiet', 'nullam', 'purus', 'lacinia','a', 'pretium', 'quis', 'congue', 'praesent', 'sagittis', 'laoreet', 'auctor', 'mauris', 'non', 'velit', 'eros','dictum', 'proin', 'accumsan', 'sapien', 'nec', 'massa','volutpat', 'venenatis', 'sed', 'eu', 'molestie', 'lacus','quisque', 'porttitor', 'ligula', 'dui', 'mollis', 'tempus','at', 'magna', 'vestibulum', 'turpis', 'ac', 'diam','tincidunt', 'id', 'condimentum', 'enim']
        },
        columnMap(){
            let obj = {...this.column_map}
            Object.keys(obj).forEach(key => {
                let value = obj[key];
                let hasProperties = value && Object.keys(value).length > 0;
                if (value === null) {
                delete obj[key];
                }
                else if ((typeof value !== "string") && hasProperties) {
                removeNullProperties(value);
                }
            });
            return obj;
        },
        concatPersonRecordsData(){
            let newData = []
            this.data.forEach( row => {



                if(row.iys_records.length==1&&row.meta_records.length==1&&row.iys_records[0].sid==row.meta_records[0].target_update_iys_record_sid){
                    let concat_records = row.meta_records
                    row.concat_records = concat_records
                    newData.push(row)
                }else{

                if(row.iys_records){
                let iysRecords = row.iys_records.map(obj=> ({ ...obj, hasIysRecord: true }))
                row.concat_records = iysRecords.concat(row.meta_records)
                newData.push(row)
                }

                else {
                    let concat_records = row.iys_records.concat(row.meta_records)
                    row.concat_records = concat_records
                    newData.push(row)
                    }

                }
            })
            return newData
        },
        filteredVendorList() {
            return this.vendors.filter((item) => item.name.toLowerCase().indexOf(this.vendorFilterKey.toLowerCase()) >= 0);
        }
    },
    mounted() {
        this.company.name = localStorage.getItem('organization_name')
        //this.getBrands()
        let brandExpression = {}
        brandExpression.fieldName = 'brand_code'
        brandExpression.operator = 'equals'
        brandExpression.filterType = "persons"

        let typeExpression = {}
        typeExpression.fieldName = 'type'
        typeExpression.operator = 'equals'
        typeExpression.value = 'ARAMA'
        typeExpression.filterType = "persons"

        this.getBrands().then((response) => {
            console.log('--getBrands success response')
            console.log(response)

            if(response.status.code == '0'){
                if(response.content.result.length!==0){
                    this.selectedBrand = response.content.result[0]
                }else{
                    this.selectedBrand = this.allBrands
                }
                //this.addExpression('brand_code', 'equals', this.selectedBrand.brand_code)
                brandExpression.value = this.selectedBrand.brand_code
                this.filter.ands.push(brandExpression)
            }
            //this.addExpression('type', 'equals', 'ARAMA')
            this.filter.ands.push(typeExpression)
            // this.addExpression('status', 'equals', 'ONAY')
            // this.addExpression('sync_status', 'equals', 'error')
            this.getPersonsF()
            // this.spin = false
            this.getDashBoardF()
            // console.log("getPersonsF in getbrands")
        }).catch(e => {
            console.log('--getBrands Error')
            console.log(e)
        })

        this.getVendors()


        var table = document.getElementsByClassName('table-wrapper')
        var self = this
        table[0].addEventListener('scroll', function(e){
            const scrollYEmit = Math.ceil(e.target.scrollTop) 
            const clientHeightEmit = e.target.clientHeight
            const scrollHeightEmit = e.target.scrollHeight

            // console.log(`scrollYEmit => ${scrollYEmit}`)
            // console.log(`clientHeightEmit => ${clientHeightEmit}`)
            // console.log(`scrollHeightEmit => ${scrollHeightEmit}`)
            
            // console.log(scrollYEmit+clientHeightEmit===scrollHeightEmit)

            if (scrollYEmit+clientHeightEmit >= scrollHeightEmit) {
                self.pagingOffset = self.pagingOffset + self.pagingSize
                self.getPersonsF('byScroll')
               
            }
        })

    },
    methods: {
        ...mapActions(['getPersons','importFile','getBulkImportTasks','getBrands','getVendors','createBulkImportTask','confirmMetaRecords','deleteMetaRecords','getDashBoard']),

        openUpsertConsentModal(mode,type,personSid){

            this.upsertConsentModal.personSid = personSid

            if(type=='number'||type=='ARAMA'||type=='MESAJ'){
                type = 'number'
            }else if(type=='email'||type=='EPOSTA'){
                type = 'email'
            }
            this.upsertConsentModal.isType = type
            this.upsertConsentModal.isMode = mode
            this.isUpsertConsentModalActive = true
            // this.spin = true

        },
        resetScroll(){
            
            var table = document.querySelector(".table-wrapper");
            table.scrollTop = 0;
        },
        getConsentType(row){

            if(row.concat_records[0] && row.concat_records[0].type){
                return row.concat_records[0].type
            }else{
                if(row.recipient.substr(0,1)=='+'){
                    return 'number'
                }else{
                    return 'email'
                }
            }


        },
        returnToUpdateMode(form){
            if(form.sid){
                this.upsertConsentModal.personSid = form.sid
                if(form.type=='number'||form.type=='ARAMA'||form.type=='MESAJ'){
                    form.type == 'number'
                }else if(form.type=='email'||form.type=='EPOSTA'){
                    form.type == 'email'
                }
                this.upsertConsentModal.isType = form.type
                this.upsertConsentModal.isMode = 'update'
            }
        },
        translateErrors(arr){
            return arr.map(e => this.$t(e));
        },
        removeExpression(index){
            this.filter.ands.splice(index, 1)
            this.resetScroll()
        },
        removeExpressionByFieldNameArray(fieldNameArray){

            for(let field in fieldNameArray){

                let foundObject = this.filter.ands.find(o => o.fieldName == fieldNameArray[field])

                if(foundObject){
                    let index = this.filter.ands.findIndex(i => i == foundObject)
                    this.filter.ands.splice(index, 1)
                }
                if(fieldNameArray[field]=='brand_code'){
                    this.selectedBrand = this.allBrands
                    this.resetScroll()
                    this.getPersonsF()
                    this.getDashBoardF()

                }
            }

        },
        addExpression(fieldName,operator,value){
            let findSyncError = this.filter.ands.findIndex( row => (row.fieldName == 'sync_status' && row.value=='error') )
            if(findSyncError!='-1'){
                this.filter.ands.splice(findSyncError,1)

            }
            if(!fieldName){
                fieldName = ""
            }
            if(!operator){
                operator = "equals"
            }
            if(!value){
                value = ""
            }
            if(!this.isInFilter(fieldName)){

                let newExpression = {}
                newExpression.fieldName = fieldName
                newExpression.operator = operator
                newExpression.value = value
                newExpression.filterType = "persons"

                this.filter.ands.push(newExpression)

                if(fieldName == 'brand_code'){
                    this.resetScroll()
                    this.getPersonsF()
                    this.getDashBoardF()
                }
            }else{
                if(fieldName == 'brand_code'){
                    let foundObject = this.filter.ands.find(o => o.fieldName == 'brand_code')

                    if(foundObject){
                        let index = this.filter.ands.findIndex(i => i == foundObject)
                        foundObject.value = value
                        this.filter.ands.splice(index, 1, foundObject)
                        this.resetScroll()
                        this.getPersonsF()
                        this.getDashBoardF()
                    }
                }
            }
        },
        isInFilter(fieldName){
            return this.filter.ands.some(f =>  f.fieldName == fieldName)
        },
        isInDashboardFilter(typeValue,statusValue){
            let selectedType = null
            let selectedStatus = null
            let selectedSnycStatus = null
            if(this.filter.ands.find(f => f.fieldName == 'type')){
                selectedType = this.filter.ands.find(f => f.fieldName == 'type').value
            }
            if(this.filter.ands.find(f => f.fieldName == 'status')){
                selectedStatus = this.filter.ands.find(f => f.fieldName == 'status').value
            }
            if(this.filter.ands.find(f => f.fieldName == 'sync_status')){
                selectedSnycStatus = this.filter.ands.find(f => f.fieldName == 'sync_status').value
            }

            if(this.isInFilter('type')){
                if((typeValue == selectedType)&&((selectedStatus==statusValue)||(selectedSnycStatus==statusValue))){
                    return true
                }else{
                    return false
                }
            }else{
                if((selectedStatus==statusValue)||(selectedSnycStatus==statusValue)){
                    return true
                }else{
                    return false
                }
            }
        },
        addExpressionFromDashboard(fieldName,operator,value,type){


            let selectedType = null
            if(this.filter.ands.find(f => f.fieldName == 'type')){
                selectedType = this.filter.ands.find(f => f.fieldName == 'type').value
            }

            let fieldNameArray = []
            if(!type){
                type = ""
                fieldNameArray.push('type')
                if(fieldName!=='status'){
                    fieldNameArray.push('status')
                }
                if(fieldName!=='sync_status'||(fieldName=='sync_status'&&value=="error")){
                    fieldNameArray.push('sync_status')
                }
            }else if(type!==selectedType){
                fieldNameArray.push('type')
                fieldNameArray.push('status')
                fieldNameArray.push('sync_status')
            }else{
                if(fieldName=='status'){
                    fieldNameArray.push('status')
                }
                if(fieldName=='sync_status'){
                    fieldNameArray.push('sync_status')
                }
            }
            this.removeExpressionByFieldNameArray(fieldNameArray)
            if(type=='ARAMA'){
                this.addExpression('type','equals','ARAMA')
            }
            if(type=='MESAJ'){
                this.addExpression('type','equals','MESAJ')

            }
            if(type=='EPOSTA'){
                this.addExpression('type','equals','EPOSTA')
            }
            if(!fieldName){
                fieldName = ""
            }
            if(!operator){
                operator = "equals"
            }
            if(!value){
                value = ""
            }
            if(!this.isInFilter(fieldName)){
                let newExpression = {}
                newExpression.fieldName = fieldName
                newExpression.operator = operator
                newExpression.value = value
                newExpression.filterType = "persons"

                this.filter.ands.push(newExpression)
                this.pagingOffset = 0
                this.resetScroll()
                this.getPersonsF()
            }

            this.pagingOffset = 0
        },

        removeExpressionFromDashboard(fieldNameArray){
            this.removeExpressionByFieldNameArray(fieldNameArray)
            this.resetScroll()
            this.getPersonsF()
        },
        removeAllExpressionsExcept(fieldNameArray){
            if(fieldNameArray){
              this.filter.ands = this.filter.ands.filter(row => fieldNameArray.includes(row.fieldName))
              this.resetScroll()
            }
        },
        clearFilterButtonF(){
            if(this.hasExtraFiledsThen(this.defaultFilters)){

                this.removeAllExpressionsExcept(this.defaultFilters)
            }else{

                this.removeExpressionFromDashboard(['type'])
            }
            this.resetScroll()
            this.getPersonsF()
            this.getDashBoardF()
        },
        renewExpression(index,newKey){

            //{"fieldName":"type","operator":"equals","value":"ARAMA","filterType":"persons"},
            let newObj = {}
            newObj.fieldName = newKey.target.value
            newObj.operator = "equals"
            newObj.value = ""
            newObj.filterType = "persons"
            this.filter.ands.splice(index, 1, newObj)

        },
        getOperatorList(key){
            // {"prop":"recipient","label":"Alıcı"},
            // {"prop":"name","label":"Ad Soyad"},
            // {"prop":"brand_code","label":"Marka"},
            // {"prop":"type","label":"İzin Tipi"},
            // {"prop":"status","label":"İzin Durumu"},
            // {"prop":"recipient_type","label":"Alıcı Tipi"},
            // {"prop":"source","label":"İzin Kaynağı"},
            // {"prop":"consent_date","label":"İzin Tarihi"},
            // {"prop":"retailer_code","label":"İzin Alan Bayi"},
            // {"prop":"retailer_access","label":"İzin Paylaşılan Bayi"},
            // {"prop":"date_created","label":"İYS Panel'e Kaydedilme Tarihi"},
            // {"prop":"iys_creation_date","label":"E-Devlete Aktarılma Tarihi"},
            // {"prop":"origin","label":"Kayıt Aracı"},
            // {"prop":"sync_status","label":"Hata Nedeni"}
            let operatorList = []

            operatorList.push({"value":"equals","label":"="})

            if(["consent_date","date_created","iys_creation_date",].includes(key)){
                operatorList.push({"value":"greater_than","label":">"})
                operatorList.push({"value":"less_than","label":"<"})
                operatorList.push({"value":"between","label":this.$t('between')})
            }
            if(["recipient","name"].includes(key)){
                operatorList.push({"value":"contains","label":this.$t('contains')})
            }
            if(key=='status'){
                operatorList.push({"value":"not_empty","label":this.$t('not_empty')})
            }
            return operatorList
        },
        openNewFilterModal(){
            this.isNewFilterModalActive = true
            this.pagingOffset = 0
            //this.$refs.filtersDropdown.toggle()
        },
        getPersonsF(emitter){
            console.log('*****getPersonsF******')
            let form = {}
            form.pagingOffset = this.pagingOffset
            form.pagingSize = this.pagingSize
            if(this.filter.ands&&this.filter.ands.length !== 0){

                let newFilter = JSON.parse(JSON.stringify(this.filter))
                let findSyncError = newFilter.ands.findIndex( row => (row.fieldName == 'sync_status' && row.value=='error') )
                if(findSyncError!='-1'){
                    let sidfilter = {fieldName: "status", operator: "empty", value: "true", filterType: "persons"}
                    this.selectedBrand = this.allBrands
                    newFilter.ands=[]
                    newFilter.ands.push(sidfilter)

                }
                let findSid = newFilter.ands.findIndex( row => row.fieldName=='sid' )
                if(findSid!='-1'){
                    let sidfilter = {fieldName: "status", operator: "empty", value: "true", filterType: "persons"}
                    this.selectedBrand = this.allBrands
                    newFilter.ands=[]
                    newFilter.ands.push(sidfilter)

                }

                form.filter = newFilter

            }
            this.spin = true
            this.getPersons(form).then((response) => {
                console.log('--getPersons success response')
                console.log(response)
                // this.data=this.persons
                this.spin = false
                if(emitter=='byScroll'){
                    this.data = this.data.concat(this.persons)
                }else{
                    this.data=this.persons
                }

            }).catch(e => {
                this.spin = false
                console.log('--getPersons Error')
                console.log(e)
            })
            
        },
        getBrand(data){
            data = data.filter(row => !row.target_update_iys_record_sid)

            if(data){
                if(data.length==0){
                    return ''
                }else if(data.length==1){
                    let brandName = this.brands.find(b => b.brand_code == data[0].brand_code)
                        if(brandName){
                            return brandName.name
                        }
                }else{
                    let isMultipleBrand=false

                    data.forEach( row => data.some(r=>{
                        if(r.brand_code!==row.brand_code){
                            isMultipleBrand=true
                        }
                    }))
                    if(isMultipleBrand){
                        return this.$t('has_consents_for_multiple_brands')
                    }else{
                        return "Birden çok izin kaydı var"
                    }

                }
            }else{
                return ''
            }
        },
        getStatusText(data){
            if(data){
                if(data.length==1){
                    return this.$t(data[0].status)
                }else{
                    return ''
                }
            }else{
                return ''
            }
            return ''
        },
        getStatusClass(data){
            if(data){
                if(data.length==1){
                    return this.consentStatusClassDict[data[0].status]
                }else{
                    return ''
                }
            }else{
                return ''
            }
            return ''
        },
        getSourceText(data){
            if(data){
                if(data.length==1){
                    //return this.$t(this.consentSourceLabelDict[data[0].source])
                    return this.$t(data[0].source)
                }else{
                    return ''
                }
            }else{
                return ''
            }
            return ''
        },
        getConsentDate(data){
            if(data){
                if(data.length==1){
                    //return this.$t(this.consentSourceLabelDict[data[0].source])
                    if(data[0].consent_date){
                        return this.$moment(data[0].consent_date.$date).format('L')
                    }else{
                        return '-'
                    }
                }
            }else{
                return ''
            }
            return ''
        },
        getConsentTime(data){
            if(data){
                if(data.length==1){
                    //return this.$t(this.consentSourceLabelDict[data[0].source])
                    if(data[0].consent_date){
                        return this.$moment(data[0].consent_date.$date).format('LTS')
                    }else{
                        return ''
                    }
                }
            }else{
                return ''
            }
            return ''
        },
        getStatusIcon(data){
            let iconSRC = ''

            data.some(row => {
                if(row.sync_status=='error_on_process'){
                    iconSRC = this.transferErrorIconUrl
                }else if(row.sync_status=='error'){
                    iconSRC = this.needInfoIconUrl
                }else if(row.sync_status == undefined && row.status == undefined && row.type == undefined){
                    iconSRC = this.needInfoIconUrl
                }else if(row.sync_status=='awaiting_confirmation' || row.sync_status=='confirmed'){
                    iconSRC = this.transferFailIconUrl
                }else{
                    iconSRC = this.transferOkIconUrl
                }
            })
            if(data.length==0){
                iconSRC = this.needInfoIconUrl
            }

            return iconSRC
        },

        getStatusIconInfo(data){
            let info = {}
            let errorMsg = 'Beklenmeyen bir hata meydana geldi. Lütfen verilerinizi kontrol edip tekrar deneyiniz.'


            data.some(row => {
                if(row.error_message){
                errorMsg = row.error_message
                }
                if(row.sync_status=='error_on_process'){
                    info.icon = 'alert'
                    info.type = 'is-danger'
                    info.text = "Kaydın e-devlete aktarılması başarısız oldu. <br/> <b>Hata Detayı:</b> "+errorMsg
                }else if(row.sync_status=='error'){
                    info.icon = 'alert'
                    info.type = 'is-danger'
                    info.text = "Kayda ait girilmeyen eksik bilgiler var. Lütfen kontrol ediniz. "
                }else if(row.sync_status=='awaiting_confirmation' || row.sync_status=='confirmed'){
                    info.icon = 'alert'
                    info.type = 'is-primary'
                    info.text = "Kayda ait e-devlet'e aktarılmayan izinler var. Lütfen kontrol ediniz."
                }
                else if(row.sync_status == undefined && row.status == undefined && row.type == undefined){
                    info.icon = 'alert'
                    info.type = 'is-danger'
                    info.text = "Kayda ait girilmeyen eksik bilgiler var. Lütfen kontrol ediniz. "
                }else{
                    info.icon = 'check-circle'
                    info.type = 'is-primary'
                    info.text = "Kayda ait tüm izinler e-devlet'e aktarılmış"
                }

            })

            return info
        },


        isEditableCol(row,col){
            let editableRow = false
            let editableCol = false
            if(row.sid==this.editRowSid&&this.editRowSid=='NEWLINE'){
                editableCol = true
                editableRow = true

            }else if(row.sid==this.editRowSid){
                editableRow = true
            }

            if(row.target_update_iys_record_sid&&row.sync_status!=='confirmed'&&!['brand_code','type','status','recipient_type','recipient','retailer',].includes(col)){

               editableCol = true
            }else if((row.hasIysRecord==true&&this.updateObject.status!=row.status&&!['brand_code','type','recipient_type','recipient','retailer'].includes(col))){
                editableCol = true
            }else if((row.hasIysRecord==true&&!['brand_code','type','recipient_type','recipient','retailer','consent_date','source'].includes(col))||(row.hasIysRecord!==true&&!row.target_update_iys_record_sid)){

                editableCol = true

            }else{
                editableCol = false
            }

            if(editableRow&&editableCol){

                return true
            }else{
                return false
            }
        },
        getVendorName(code){
            if(code){

                let vendorName = this.vendors.find((v)=>{ return v.iys_vendor_code == code }).name

                if(vendorName){
                    return vendorName
                }else{
                    return ""
                }
            }else{
                return ""
            }
        },
        //take a single JavaScript File object
        getFile(file) {
            var reader = new FileReader();
            return new Promise((resolve, reject) => {
                reader.onerror = () => {
                    reader.abort();
                    reject(new Error("Error parsing file"));
                }
                reader.onload = function () {

                    //This will result in an array that will be recognized by C#.NET WebApi as a byte[]
                    let bytes = Array.from(new Uint8Array(this.result));

                    //if you want the base64encoded file you would use the below line:
                    let base64StringFile = btoa(bytes.map((item) => String.fromCharCode(item)).join(""));

                    //Resolve the promise with your custom file structure
                    resolve({
                        bytes: bytes,
                        base64StringFile: base64StringFile,
                        fileName: file.name,
                        fileType: file.type
                    });
                }
                reader.readAsArrayBuffer(file);
            });
        },
        readFile(){
            this.getFile(this.selectedFile).then((customJsonFile) => {
                this.uploadedFile.fileContent=customJsonFile['base64StringFile'];
                this.uploadedFile.fileName=customJsonFile['fileName']
            })
        },
        sendFileF(){
            this.importFile(this.uploadedFile).then((response) => {
                console.log('--importFile success response')
                console.log(response)
                this.isExcelUploadModalActive=false
                this.isColumnMatchModalActive=true
                this.validateForm()
            }).catch(e => {
                console.log('--importFile Error')
                console.log(e)
            })
        },
        goBackExcelModal(){
            this.isExcelUploadModalActive=true
            this.isColumnMatchModalActive=false
        },
        validateForm(){

            this.formValidationErrors=[]

            if(this.imported_file.sid==undefined){
                let error = this.$t('file_is_required')
                this.formValidationErrors.push(error)
            }

            if(this.operation_type==null){
                let error = this.$t('import_type_is_required')
                this.formValidationErrors.push(error)
            }

            if(this.brand_codes.length==0){
                let error = this.$t('brand_codes_are_required')
                this.formValidationErrors.push(error)
            }

            // if(Object.values(this.column_map).includes(null)){
            //     let error = this.$t('match_all_columns_is_required')
            //     this.formValidationErrors.push(error)
            // }

            if(this.column_map.recipient == null || this.column_map.recipient_type == null || this.column_map.status == null || this.column_map.transaction_type == null ){
                let error = this.$t('required_columns_not_selected')
                this.formValidationErrors.push(error)
            }
        },
        createBulkImportTaskF(){

            this.validateForm()
            if(this.formValidationErrors.length==0){
                let form = {}
                //token,
                form.userDocumentSid = this.imported_file.sid //"asd12asd123asd"
                form.brand_codes = this.brand_codes
                form.vendor_codes = this.vendor_codes // ["1231231","345345" ...] -vendor codes zorunlu değil
                form.column_map = this.columnMap // {"status":5, "source":2 ..}
                form.hasHeaderRow = this.uploadedFile.hasHeaderRow //set edilmezse false kabul edilecek boolean fieldlar
                form.operation_type = this.operation_type //"update","insert","upsert" ten biri



                this.createBulkImportTask(form).then((response) => {
                    console.log('--createBulkImportTask success response')
                    console.log(response)
                    //this.isExcelUploadModalActive=false
                    this.isColumnMatchModalActive=false
                    this.$buefy.dialog.confirm({
                        title: this.$t('import_details'),
                        message: '<p>'+this.$t('import_details_text1')+'</p><br/><p>'+this.$t('import_details_text2')+'</p>',
                        type: 'is-primary',
                        hasIcon: true,
                        icon: 'arrow-expand-up',
                        cancelText: this.$t('close'),
                        confirmText: this.$t('import_history'),
                        onConfirm: () => this.$router.push('/importHistory')
                    })
                }).catch(e => {
                    console.log('--createBulkImportTask Error')
                    console.log(e)
                })
            }
        },
        clearVendors(){
            this.all_vendors_selected=false
            this.vendor_codes = []
        },
        clearBrands(){
            this.all_brands_selected=false
            this.all_vendors_selected=false
            this.brand_codes = []
        },
        brandCheckboxToggle(e){
            if(this.brand_codes.includes(e)){
                this.vendors.forEach( item => {
                    if(item.brand_code==e){
                        let index = this.brand_codes.indexOf(item.brand_code)
                        this.vendor_codes.splice(index,1)
                    }
                })
            }
        },
        getDashBoardF(){
            let form = {}
            if(this.isInFilter('brand_code')){
                let list = []
                list.push(this.filter.ands.find(f =>  f.fieldName == 'brand_code').value)
                form.brands = list
            }
                this.getDashBoard(form).then((response) => {
                    console.log('--getDashBoard success response')
                    console.log(response)
                    //this.isExcelUploadModalActive=false
                    this.pagingOffset = 0

                }).catch(e => {
                    console.log('--getDashBoard Error')
                    console.log(e)
                })
        },
        setBrandFromFilter(brandCode){
            //let brandCode = fil.ands.find( row => row.fieldName == 'brand_code').value
            if(brandCode){
                this.selectedBrand = this.brands.find( i => i.brand_code == brandCode)
                //if(!this.isInFilter('')){
                this.getPersonsF()
                this.getDashBoardF()


                //}
            }
        },
        hasExtraFiledsThen(fieldNameArray){
            const extraFields  = this.filter.ands.filter(row => !fieldNameArray.includes(row.fieldName))
            if(extraFields.length>0){
                return true
            }else{
                return false
            }
        },
        confirmMetaRecordsF(){

            this.$buefy.dialog.confirm({
                title: "İzin Aktarım Onayı",
                message: "İzinlerinizi e-devlet paneline aktarmak üzeresiniz. Aktarım başladıktan sonra birçok izin bilgisini değiştirmeniz mümkün olmayacaktır. Onaylıyor musunuz?",
                type: 'is-primary',
                hasIcon: true,
                cancelText: this.$t('cancel'),
                confirmText: "İzinleri Aktar",
                onConfirm: () => {
                    let form={}
                    form.sid_values = this.sidValues
                    // console.log("form")
                    // console.log(form)

                    this.confirmMetaRecords(form).then((response) => {
                        // console.log('--confirmMetaRecords success response')
                        console.log(response)
                        this.$buefy.dialog.confirm({
                            title: "Aktarım Başladı",
                            message: "İzinlerin listenizde görünmesi kısa bir süre alabilir.",
                            type: 'is-success',
                            hasIcon: true,
                            canCancel:false,
                            confirmText: "Tamam",
                            onConfirm: () => {
                                this.$emit('close')
                            }
                        })
                    }).catch(e => {
                        // console.log('--confirmMetaRecords Error')
                        console.log(e)
                    })
                }
            })

        },
        confirmCloseUpsertModal(){
            let hasNotTransferedConsents = false
            this.concat_records.some(row => {
                if(row.sync_status == 'awaiting_confirmation'){
                    hasNotTransferedConsents=true
                }
            })

            if(hasNotTransferedConsents){
                this.$buefy.dialog.confirm({
                    title: "Aktarım Yapılmayacak",
                    message: "İzinleri aktarmama kararı aldınız. Alındığı tarihten sonra 3 iş gününde aktarılmayan izinler geçersiz sayılacaktır. En kısa sürede izinlerinizi aktarın.",
                    type: 'is-warning',
                    hasIcon: true,
                    cancelText: this.$t('cancel'),
                    confirmText: "Kaydet ve Devam Et",
                    onConfirm: () => {
                        this.$emit('close')
                    }
                })
            }else{
                this.$emit('close')
            }
        },
       isCheckedF(){
           if(this.isChecked){
               this.isChecked = false
           }
       },


    },
    watch:{
        all_brands_selected(val){
            if(val){
                this.brand_codes = Array.from(this.brands, brand => brand = brand.brand_code)
            }else{
                this.brand_codes = []
                this.all_vendors_selected=false
            }
        },
        all_vendors_selected(val){
            if(val){
                this.vendor_codes = Array.from(this.vendors.filter( vendor => this.brand_codes.includes(vendor.brand_code)), item => item= item.iys_vendor_code)
            }else{
                this.vendor_codes = []
            }
        },
        brand_codes(){
            if(this.all_vendors_selected){
                this.vendor_codes = Array.from(this.vendors.filter( vendor => this.brand_codes.includes(vendor.brand_code)), item => item= item.iys_vendor_code)
            }
            this.validateForm()
        },
        vendorFilter(key){
            this.vendors.forEach((v) => {
                if(!v.name.includes(key)){
                    v['visible']=false
                }else{
                    v['visible']=true
                }
            })
        },
        operation_type(){
            this.validateForm()
        },
        column_map:{
            handler(){

                this.validateForm()
            },
            deep:true
        },
        selectedBrand(obj){

            if(obj.brand_code=='ALL'){
                this.removeExpressionFromDashboard(['brand_code'])
            }
        }
    },
    created() {
        // this.getPersonsF()
    },
    filters: {
        shortName:function(name,len){
            if(name){
                if ( name.length > len ) {
                    return name.substring(0,len) + '...'
                } else {
                    return name
                }
            }
        }
    }
}
</script>
<style scoped>
    .list-panel-header{
        border-radius: 16px 16px 0 0;
        min-height: 80px;
    }
    .dashicon{
        width: 20px;
    }
    .dashtitle{
        font-size: 0.6875rem;
    }
    .dashvalue{
        font-weight: 600;
        font-size: 1.125rem;
        line-height: 1;
    }
    .status-tag{
        min-width: 50px;
    }
    .excel-sample-images{
        height: 178px;
    }
    .column-match-wrapper span.tag{
        min-width: 170px;
        justify-content: left;
    }
    .brand-checkbox-list{
        overflow-y:auto ;
        height: 150px;
    }
    .vendor-checkbox-list{
        overflow-y:auto ;
        height: 94px;
    }
    .truncated-tag-list{
        display: block;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .tag-list-label{
        white-space: nowrap;
    }
    .dd-brand-list-wrapper{
        height: 150px;
        overflow-y:auto;
    }
    .import-e-government{
        background: #CEE0F5;
        padding: 1rem 1rem 1rem 1rem;
        margin: 0;
    }

</style>


// WEBPACK FOOTER //
// src/components/Home.vue